module.exports = __webpack_public_path__ + "img/twitter-circle-white-48px.19aa0bf.svg";